module.exports = __webpack_public_path__ + "static/media/GrabWebIcon-v1.7.0.6ab0baf9.eot";